import { keycloakAuthUrl } from 'src/config';
import { paths } from 'src/paths';

const { landingPage } = paths;

export const generateUrlForKeyclockLogin: Function = (isLogOut = false) => {
  const realm = !isLogOut ? exctractSubdomain() : getRealmNameForLocalLogout();
  const buildUrl = new URLSearchParams();
  buildUrl.append('response_type', 'code');
  buildUrl.append('client_id', 'js-client');
  buildUrl.append('client_secret', '');
  buildUrl.append('scope', 'openid');
  buildUrl.append('redirect_uri', `${window.location.origin}${landingPage}`);
  return `${keycloakAuthUrl}/${realm}/protocol/openid-connect/auth?${buildUrl.toString()}`;
};

export const exctractSubdomain = () => {
  const checkHost = window.location.hostname;
  if (checkHost === 'localhost' || checkHost === '127.0.0.1') {
    localStorage.setItem('realm', window.location.pathname.split('/')[1]);
    return window.location.pathname.split('/')[1];
  } else {
    return checkHost.split('-')[0];
  }
};

export const getRealmNameForLocalLogout = () => {
  const checkHost = window.location.hostname;
  const pullRealmName =
    checkHost === 'localhost' || checkHost === '127.0.0.1'
      ? localStorage.getItem('realm')
      : exctractSubdomain();
  localStorage.removeItem('realm');
  return pullRealmName;
};
